function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1 1l26 26M27 1L1 27",
  stroke: "#181EA9"
});

function SvgCross(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMUwyNyAyNyIgc3Ryb2tlPSIjMTgxRUE5Ii8+CjxwYXRoIGQ9Ik0yNyAxTDEgMjciIHN0cm9rZT0iIzE4MUVBOSIvPgo8L3N2Zz4K";
export { SvgCross as ReactComponent };